require("!!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/script-loader/addScript.js")(require("!!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/raw-loader/index.js!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/jquery-sparkline/jquery.sparkline.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery-sparkline/jquery.sparkline.js
// module id = 750
// module chunks = 15